<script>
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter.vue';
import { BuildingsService } from '@/services/buildings.service';

export default {
  name: 'SelectPossessionForm',

  extends: BaseSelectFilter,

  methods: {
    refreshData() {
      BuildingsService.getPossessionForm().then(items => {
        this.items = items.data.data;
      });
    }
  }
};
</script>
